import { Button } from '@/components/Button/Button';

import styles from './SelectionToolbar.module.css';

interface SelectionToolbarProps {
  disabled?: boolean;
  onCancel(): void;
  onCopy(): void;
  onDelete(): void;
  selectedCount: number;
}

export function SelectionToolbar({
  disabled = false,
  onCancel,
  onCopy,
  onDelete,
  selectedCount,
}: SelectionToolbarProps) {
  const label =
    selectedCount === 1 ? '1 section selected' : `${selectedCount} sections selected`;

  return (
    <div className={styles.toolbar} role="group" aria-label="Selected sections">
      <p aria-live="polite" className={styles.count}>
        {label}
      </p>
      <div className={styles.actions}>
        <Button onClick={onCancel} size="small" variant="secondary">
          Cancel
        </Button>
        <Button
          disabled={disabled || selectedCount === 0}
          onClick={onCopy}
          size="small"
          variant="secondary"
        >
          Copy
        </Button>
        <Button
          destructive
          disabled={disabled || selectedCount === 0}
          onClick={onDelete}
          size="small"
        >
          Delete
        </Button>
      </div>
    </div>
  );
}
